<!--
Card component, for displaying content in a styled box.

Props:
- title: The title of the card.
- inner: If true, uses a smaller padding and a different background color.
- class: Additional CSS classes to apply to the card.
- renderBody: The slot content to render inside the card body.
- cardControls: Optional component to render controls in the card header.

Licensed under MIT (C) Alicia Sykes 2025 <https://github.com/lissy93>
-->

<section
  class=(`
    rounded-xl border border-gray-700
    ${input.inner ? 'bg-slate-900/60 p-2 sm:p-3 ' : 'bg-gray-800 p-3 sm:p-5 '}
    ${input.class}
  `)
>
  <!-- Card header (and optional right-aligned buttons/controls) -->
  <div class="flex items-center justify-between flex-wrap">
    <if(input.inner)>
      <h4 class="text-white-300 text-lg mb-2">${input.title}</h4>
    </if>
    <else-if(input.main)>
      <h1 class="text-green-300 text-4xl mb-4 font-semibold">${input.title}</h1>
    </else-if>
    <else>
      <h3 class="text-green-300 text-2xl mb-3">${input.title}</h3>
    </else>
    <if(input.cardControls)>
      <div>
        <${input.cardControls}/>
      </div>
    </if>
  </div>
  <!-- Card content -->
  <${input.renderBody}/>
</section>
